interface TabSectionProps {
    currentActiveNav: number;
    activeNavValue: number;
    children: JSX.Element | JSX.Element[];
}

const TabSeccion = ({
    currentActiveNav,
    activeNavValue,
    children,
}: TabSectionProps) => {
    return (
        <div
            className={`tab-pane ${currentActiveNav == activeNavValue && 'active'}`}
        >
            {children}
        </div>
    );
};

export default TabSeccion;
